import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Create client with better configuration
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  },
  realtime: {
    params: {
      eventsPerSecond: 2
    }
  },
  global: {
    headers: {
      'x-client-info': 'erp-v2'
    }
  }
});

// Add connection health check
let isConnected = false;
let connectionCheckPromise: Promise<boolean> | null = null;

export const checkConnection = async (): Promise<boolean> => {
  if (connectionCheckPromise) {
    return connectionCheckPromise;
  }

  connectionCheckPromise = new Promise(async (resolve) => {
    try {
      const { error } = await supabase.from('project_templates').select('id').limit(1);
      isConnected = !error;
      resolve(isConnected);
    } catch (error) {
      console.error('Supabase connection error:', error);
      isConnected = false;
      resolve(false);
    } finally {
      connectionCheckPromise = null;
    }
  });

  return connectionCheckPromise;
};

// Export helper for checking connection status
export const getConnectionStatus = () => isConnected;

// Initialize connection check
checkConnection().catch(console.error);